import { ValueOf } from '@/types/util';

export const EWalletUserType = {
  PRINCIPAL: 'アプリユーザ',
  GUEST: 'ゲストユーザ',
} as const;

export type WalletUserTypeKey = keyof typeof EWalletUserType;
export type WalletUserTypeValue = ValueOf<typeof EWalletUserType>;

export const WalletUserTypeKeys = Object.keys(EWalletUserType) as WalletUserTypeKey[];

/** v-select用items */
export const WalletUserTypeItems = WalletUserTypeKeys
  .map((key) => ({
    title: EWalletUserType[key],
    value: key,
  }));
